// Get the query string from the current URL
const params = new URLSearchParams(window.location.search);

// Example: extract specific parameters
const aic = params.get('aic');

if (aic) {
    window.affiliateCode = aic;
    sessionStorage.setItem("affiliateCode", aic);
    // if (window.discountManager) {
    //     window.discountManager.hasAffiliateCode = true;
    // }
} else {
    sessionStorage.removeItem("affiliateCode");
}
